import { userRoleVal } from "utils/constants";

export const GET_ROLE = `GET_ROLE`;
export const GET_DETAILS = `GET_DETAILS`;
export const GET_DIVISION = `GET_DIVISION`;
export const GET_DISTRICT = `GET_DISTRICT`;
export const GET_STORE = `GET_STORE`;
export const GET_STORE_DISTRICT = `GET_STORE_DISTRICT`;
export const GET_LOCATION = `GET_LOCATION`;
export const GET_SEARCHRESULT = `GET_SEARCHRESULT`
export const GET_CUSTOMER_COMMENTS = `GET_CUSTOMER_COMMENTS`
export const GET_EXPORTTOEXCEL = `GET_EXPORTTOEXCEL`
export const GET_APIMKEY = `GET_APIMKEY`
export const GET_USERSFKEYMAP = `GET_USERSFKEYMAP`
export const GET_ISSUES = `GET_ISSUES`
export const GET_ACCESSDETAILS = `GET_ACCESSDETAILS`
export const GET_SOURCE = `GET_SOURCE`
export const GET_CATEGORY = `GET_CATEGORY`
export const GET_STATUS = `GET_STATUS`
export const GET_COMMENTTYPE = `GET_COMMENTTYPE`

export const SET_ROLE = `SET_ROLE`;
export const SET_DETAILS = `SET_DETAILS`;
export const SET_DIVISION = `SET_DIVISION`;
export const SET_DISTRICT = `SET_DISTRICT`;
export const SET_STORE = `SET_STORE`;
export const SET_STORE_DISTRICT = `SET_STORE_DISTRICT`;
export const SET_LOCATION = `SET_LOCATION`;
export const SET_SEARCHRESULT = `SET_SEARCHRESULT`
export const SET_CUSTOMER_COMMENTS = `SET_CUSTOMER_COMMENTS`
export const SET_EXPORTTOEXCEL = `SET_EXPORTTOEXCEL`
export const SET_APIMKEY = `SET_APIMKEY`
export const SET_USERSFKEYMAP = `SET_USERSFKEYMAP`
export const SET_ISSUES = `SET_ISSUES`
export const SET_ACCESSDETAILS = `SET_ACCESSDETAILS`
export const SET_SOURCE = `SET_SOURCE`
export const SET_CATEGORY = `SET_CATEGORY`
export const SET_STATUS = `SET_STATUS`
export const SET_COMMENTTYPE = `SET_COMMENTTYPE`


export const getAPIMKey = () => ({
    type: GET_APIMKEY
})

export const setAPIMKey = (data) => ({
    type: SET_APIMKEY,
    value: data
})

export const getAccessDetails = (userInfo) => ({
    type: GET_ACCESSDETAILS,
    value: userInfo
})

export const setAccessDetails = (data) => ({
    type: SET_ACCESSDETAILS,
    value: data
})

export const getUserSFKeyMap = (ctlPriorityData) => ({
    type: GET_USERSFKEYMAP,
    ctlPriorityData:ctlPriorityData
})

export const setUserSFKeyMap = (data) => ({
    type: SET_USERSFKEYMAP,
    value: data
})


export const getRole = () => ({
    type: GET_ROLE
})

export const setRole = (data) => ({
    type: SET_ROLE,
    value: data
});

export const getDetails = (role) => ({
    type: GET_DETAILS,
    payload: role
})

export const setDetails = (data) => ({
    type: SET_DETAILS,
    value: data
});

export const getDivision = () => ({
    type: GET_DIVISION,
})

export const getIssues = () => ({
    type: GET_ISSUES,
})

export const getSource = () => ({
    type: GET_SOURCE,
})

export const getCategory = () => ({
    type: GET_CATEGORY,
})

export const getStatus = () => ({
    type: GET_STATUS,
})

export const getCommenttype = () => ({
    type: GET_COMMENTTYPE,
})

// export const getDistrict =() =>({
//     type: GET_DISTRICT
// })

export const getDistrictByDivisionId = (divId) => ({
    type: GET_DISTRICT,
    payload: divId
})

export const getStoreByDistrictId = (disId) => ({
    type: GET_STORE_DISTRICT,
    payload: disId
})

export const getSearchResult = (searchObj, fieldName, sortBy, pageNo, rowCount) => ({
    type: GET_SEARCHRESULT,
    value: searchObj,
    sortBy: sortBy,
    pageNo: pageNo,
    fieldName: fieldName,
    rowCount: rowCount

})
export const getExportToExcel = (searchObj, fieldName, sortBy, pageNo, rowCount) => ({
    type: GET_EXPORTTOEXCEL,
    value: searchObj,
    sortBy: sortBy,
    pageNo: pageNo,
    fieldName: fieldName,
    rowCount: rowCount

})

// export const getStore =() =>({
//     type: GET_STORE
// })

export const getStoreByDivisionId = (divId) => ({
    type: GET_STORE,
    payload: divId
})

export const getLocation = () => ({
    type: GET_LOCATION
})

export const getCustomerComments = () => ({
    type: GET_CUSTOMER_COMMENTS
})
export const setDivision = (data) => ({
    type: SET_DIVISION,
    value: data
})

export const setIssues = (data) => ({
    type: SET_ISSUES,
    value: data
})

export const setSource = (data) => ({
    type: SET_SOURCE,
    value: data
})

export const setCategory = (data) => ({
    type: SET_CATEGORY,
    value: data
})

export const setStatus = (data) => ({
    type: SET_STATUS,
    value: data
})

export const setCommentType = (data) => ({
    type: SET_COMMENTTYPE,
    value: data
})

export const setDistrict = (data) => ({
    type: SET_DISTRICT,
    value: data
})
export const setSearchResult = (data) => ({
    type: SET_SEARCHRESULT,
    value: data
})
export const setExportToExcel = (data) => ({
    type: SET_EXPORTTOEXCEL,
    value: data
})

export const setStore = (data) => ({
    type: SET_STORE,
    value: data
})

export const setStoreByDistrict = (data) => ({
    type: SET_STORE_DISTRICT,
    value: data
})

export const setLocation = (data) => ({
    type: SET_LOCATION,
    value: data
})

export const setCustomerComments = (data) => ({
    type: SET_CUSTOMER_COMMENTS,
    value: data
})

export const checkRoleAndData = (role, details) => {
    let err = { error: true, fields: '', errMsg: '' }
    if (role === userRoleVal.store || role === userRoleVal.storePharmacy) {
        if (!details.divisionName || !details.districtName || !details.storeName) {
            let erTmp = ''
            let errmsg = 'Mandatory fields:'
            if (!details.divisionName) {
                erTmp = `${erTmp} division`
                errmsg = `${errmsg} division`
            }
            if (!details.districtName) {
                erTmp = `${erTmp} district`
                errmsg = `${errmsg} district`
            }
            if (!details.storeName) {
                erTmp = `${erTmp} store`
                errmsg = `${errmsg} store`
            }
            err = { error: false, fields: erTmp, msg: errmsg }
        }
    } else if (role === userRoleVal.district) {
        if (!details.divisionName || !details.districtName) {
            let erTmp = ''
            let errmsg = 'Mandatory fields:'
            if (!details.divisionName) {
                erTmp = `${erTmp} division`
                errmsg = `${errmsg} division`
            }
            if (!details.districtName) {
                erTmp = `${erTmp} district`
                errmsg = `${errmsg} district`
            }
            err = { error: false, fields: erTmp, msg: errmsg }
        }
    } else if (role === userRoleVal.division) {
        let erTmp = ''
        let errmsg = 'Mandatory fields:'
        if (!details.divisionName) {
            erTmp = `${erTmp} division`
            errmsg = `${errmsg} division`
            err = { error: false, fields: erTmp, msg: errmsg }
        }
    }
    return err;
}